<template>
  <main :class="b()">
    <div :class="b('inner')">
      <slot></slot>
    </div>

    <c-sticky-toolbar v-if="stickyToolbar && isTheme('default')" />
  </main>
</template>

<script>
  import cStickyToolbar from '@/components/c-sticky-toolbar.vue';
  import themes from '@/mixins/themes.js';

  export default {
    name: 'l-cms',

    components: {
      cStickyToolbar,
    },
    mixins: [themes],

    props: {
      /*
       * Toggle use of the integrated sticky toolbar.
       */
      stickyToolbar: {
        type: Boolean,
        default: true,
      },
    },
    // data() {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  // @use '@/setup/scss/variables';
  // @use '@/setup/scss/mixins';
  @use '@/setup/scss/extends' as *;
  // @use '@/setup/scss/functions';

  l-cms,
  .l-cms {
    @extend %layout;

    display: flex;
    flex-direction: column;

    &__inner {
      flex-grow: 1;
    }
  }
</style>
